function workHourColorScale(choice) {
	return {
		'ก. 6 - 7 ชม.': '#ffd6cf',
		'ข. 7 - 8 ชม.': '#f5aba0',
		'ค. 8 - 9 ชม.': '#e77f73',
		'ง. 9 - 10 ชม.': '#d5514a'
	}[choice];
}

function gdpGrowthColorScale(choice) {
	return {
		'ก. ขยายตัวประมาณ 2%': '#90ddff',
		'ข. ขยายตัวประมาณ 3%': '#64aacd',
		'ค. ขยายตัวประมาณ 4%': '#38799c',
		'ง. ขยายตัวประมาณ 5%': '#004c6d'
	}[choice];
}

export { workHourColorScale, gdpGrowthColorScale };
